import React, { lazy } from 'react';

const PayslipManage = lazy(() => import('./Payslip/PayslipManage'));

export const salaryPageRoutes = [
  { path: '/salary/payslip', component: PayslipManage }
];

export default salaryPageRoutes;
